module.exports = __webpack_public_path__ + "resources/img/solution_commerce_rescue6.e2cae7d8bf296d59ac6c281eb453ea07.png";